/* eslint-disable no-console */
import firebase from 'firebase';

import { TransactionRepo } from '../repository/transaction';

class CustomFirebase { // eslint-disable-line fp/no-class
  constructor() {
    this.database = null;
    this.business = null;
  }

  init(config) {
    this.database = firebase.initializeApp(config);
  }

  connection() {
    return this.database.firestore();
  }

  setBusiness(biz) {
    this.business = biz;
    this.loadToken();
  }

  async authFirebase(token) {
    try {
      await this.database.auth().signInWithCustomToken(token);
      console.debug('Firebase authenticated');
    } catch (error) {
      console.error('ERROR: CustomFirebase: database.auth().signInWithCustomToken()', error);
    }
  }

  async loadToken() {
    try {
      const { data: { token } } = await TransactionRepo.getToken(this.business);
      this.authFirebase(token);
    } catch (error) {
      console.log('Error fetching business token');
      console.log(error);
    }
  }
}

export default new CustomFirebase();
